import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PR_OPTS, TYPE_OPTS, prStyle, typeStyle } from '../utils/planHelpers';
export function DropdownMenu({ x, y, rowId, field, currentValue, onPick }) {
    const isType = field === 'type';
    const opts = isType ? TYPE_OPTS : PR_OPTS;
    return (_jsx("div", { "data-menu-keep": "1", style: {
            position: 'fixed',
            left: x,
            top: y,
            zIndex: 70,
            background: '#FFFFFF',
            border: '1px solid #E2E8F0',
            borderRadius: 10,
            boxShadow: '0 12px 28px rgba(15,23,42,.18)',
            padding: 5,
            minWidth: 118,
            display: 'flex',
            flexDirection: 'column',
            gap: 1,
        }, children: opts.map((opt) => {
            const s = isType ? typeStyle(opt.v === '—' ? '' : opt.v) : prStyle(opt.v === '—' ? '' : opt.v);
            const active = opt.v === currentValue;
            return (_jsxs("button", { type: "button", "data-row": rowId, "data-field": field, onClick: (e) => {
                    e.stopPropagation();
                    onPick(rowId, field, opt.v);
                }, className: "kp-option", style: {
                    display: 'flex',
                    alignItems: 'center',
                    gap: 8,
                    width: '100%',
                    border: 'none',
                    background: active ? '#EFF6FF' : 'none',
                    padding: '6px 8px',
                    cursor: 'pointer',
                    borderRadius: 6,
                    textAlign: 'left',
                }, children: [_jsx("span", { style: {
                            fontSize: 10.5,
                            fontWeight: isType ? 600 : 700,
                            padding: isType ? '2px 7px' : '2px 9px',
                            borderRadius: isType ? 5 : 999,
                            background: s.bg,
                            color: s.color,
                            border: `1px solid ${'bd' in s ? s.bd : 'transparent'}`,
                            whiteSpace: 'nowrap',
                        }, children: opt.label }), _jsx("span", { style: {
                            marginLeft: 'auto',
                            fontSize: 11,
                            color: '#2563EB',
                            fontWeight: 700,
                            visibility: active ? 'visible' : 'hidden',
                        }, children: "\u2713" })] }, opt.v));
        }) }));
}
